/**
 * VisitorTracker.jsx
 *
 * Silent component mounted globally in App.js.
 * Activates visitor presence tracking for every page view —
 * anonymous or authenticated. Powers /admin/live-support.
 */
import { useEffect } from "react";
import { useVisitorPresence } from "../hooks/useVisitorPresence";
import { recordVisit } from "../utils/analytics";
import { useAuth } from "../context/AuthContext";

export default function VisitorTracker() {
  useVisitorPresence();
  const { currentUser, loading } = useAuth();

  // Record one storefront visit per session (powers Store Performance + weekly report).
  // Waits for auth so signed-in visitors are recorded by name.
  useEffect(() => {
    if (loading) return;
    recordVisit({
      userEmail: currentUser?.email || null,
      userName: currentUser?.displayName || null,
    });
  }, [loading, currentUser]);

  return null;
}
